<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Status</b>
    </sui-card-content>
    <a class="content" @click="actions.hostUpdate ? onClick() : () => {}">
      <sui-loader class="blue" active centered inline size="huge" v-if="inProgress && !inQueue" />
      <i class="clock blue inverted big circular fitted icon" v-if="inQueue" />
      <i class="inverted big circular fitted icon" :class="[status.icon, status.color]" v-if="!inProgress" />
      <b>{{status.text}}</b>
      <div class="aside">
        <sui-button attached="left" size="mini" color="blue" v-if="host.process">
          <Timer :started="host.processStarted" :active="!host.lastResult" />
        </sui-button>
      </div>
    </a>
    <sui-button-group class="fluid" size="mini" attached="bottom">
      <sui-button :disabled="!actions.hostUpdate" data-goal="HOST_PAGE_RECREATE" v-if="buttons.recreate" @click="recreate()">Create</sui-button>
      <sui-button :disabled="!actions.hostUpdate" data-goal="HOST_PAGE_RESETUP" v-if="buttons.resetup" @click="resetup()">Setup</sui-button>
      <sui-button :disabled="!actions.hostUpdate" data-goal="HOST_PAGE_RESTART" v-if="buttons.restart" @click="restart()">Restart</sui-button>
      <sui-button :disabled="!actions.hostUpdate" data-goal="HOST_PAGE_START" v-if="buttons.start" @click="start()">Start</sui-button>
      <sui-button :disabled="!actions.hostUpdate" data-goal="HOST_PAGE_STOP" v-if="buttons.stop" @click="stop()">Stop</sui-button>
      <sui-button :disabled="!actions.hostUpdate" data-goal="HOST_PAGE_CANCEL" v-if="buttons.cancel" @click="cancelTask()">Cancel</sui-button>
    </sui-button-group>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'HostStatusCard',
    props: {
      host: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['actionsById']),
      actions() {
        return this.actionsById[this.host.id]
      },
      status() {
        return this.host._status
      },
      isOnline() {
        return this.host._isOnline
      },
      isCreated() {
        return this.host._isCreated
      },
      isSetup() {
        return this.host.deployable && this.host.ipAddress
      },
      inProgress() {
        return this.host._inProgress
      },
      inQueue() {
        return this.host._inQueue
      },
      buttons() {
        const methods = this.host.constructor.methods
        if (this.inProgress) {
          return {cancel: true}
        }
        if (!this.isCreated) {
          return {recreate: methods.recreate}
        }
        if (!this.isSetup) {
          return {resetup: methods.resetup}
        }
        if (!this.isOnline) {
          return {start: methods.start}
        }
        return {
          restart: methods.restart,
          stop: methods.stop,
        }
      },
    },
    methods: {
      recreate() {
        this.host.recreate().catch(error => {
          this.$emit('error', error.message)
        })
      },
      resetup() {
        this.host.setup().catch(error => {
          this.$emit('error', error.message)
        })
      },
      restart() {
        return this.$modals.confirm.open({
          text: 'You are going to restart the host.',
          callback: () => {
            this.host.restart().catch(error => {
              this.$emit('error', error.message)
            })
          },
        })
      },
      start() {
        return this.$modals.confirm.open({
          text: 'You are going to start the host.',
          callback: () => {
            this.host.start().catch(error => {
              this.$emit('error', error.message)
            })
          },
        })
      },
      stop() {
        return this.$modals.confirm.open({
          text: 'You are going to stop the host.<hr class="ui divider"><small><b>Pay attention!</b> When you stop your host, the other hosts start updating the network. The process usually takes 1-5 minutes, and some of the hosts might be unavailable during this time. So do not do it too often to keep the network stable.</small>',
          callback: () => {
            this.host.stop().catch(error => {
              this.$emit('error', error.message)
            })
          },
        })
      },
      cancelTask() {
        return this.$modals.confirm.open({
          text: 'You are going to cancel the process.',
          callback: () => {
            this.host.cancelTask().catch(error => {
              this.$emit('error', error.message)
            })
          },
        })
      },
      onClick() {
        if (!this.isCreated) {
          return this.recreate()
        }
        if (!this.isSetup) {
          return this.resetup()
        }
        if (this.isOnline) {
          return this.restart()
        }
        if (!this.isOnline) {
          return this.start()
        }
      },
    },
  }
</script>

<style scoped>
  .ui.inline.loader { display: inline-block!important; width: 1em!important; height: 1em!important; font-size: 4em!important; }
  .ui.inline.loader:before { width: 100%; height: 100%; left: 0; margin: 0; }
  .ui.inline.loader:after { width: 100%; height: 100%; left: 0; margin: 0; }
  .aside { position: absolute; right: 0; top: 5%; max-height: 90%; display: flex; flex-direction: column; align-items: flex-start; }
  .aside .button { padding: .4em!important; font-size: .8em!important; white-space: nowrap; }
</style>
